'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reduxForm = require('redux-form');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _ramda = require('ramda');
var _lodash = require('lodash');

var _FeedbackIncreaseLimits = require('./FeedbackIncreaseLimits');var _FeedbackIncreaseLimits2 = _interopRequireDefault(_FeedbackIncreaseLimits);
var _feedbackIncreaseLimits = require('../../redux/modules/feedbackIncreaseLimits');
var _messageModal = require('../../redux/modules/messageModal');

var _validate = require('./validate');var _validate2 = _interopRequireDefault(_validate);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var selector = (0, _reduxForm.formValueSelector)('feedbackIncreaseLimits');

var mapStateToProps = function mapStateToProps(state) {return {
    fields: {
      name: selector(state, 'name'),
      phone_number: selector(state, 'phone_number'),
      email: selector(state, 'email'),
      message: selector(state, 'message') },

    initialValues: {
      name: (0, _lodash.get)(state, 'userAuthentication.data.display_name', ''),
      email: (0, _lodash.get)(state, 'userAuthentication.data.email', '') },

    userToken: (0, _lodash.get)(state, 'userAuthentication.data.access_token'),
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    userData: (0, _lodash.get)(state, 'userAuthentication.data'),
    isMessageModalOpen: state.messageModal.isMessageModalOpen,
    foreignLimit: state.foreignLimit };};exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, {
  askForeignLimit: _feedbackIncreaseLimits.askForeignLimit,
  hideMessageModal: _messageModal.hideMessageModal,
  openMessageModal: _messageModal.openMessageModal }),

(0, _reduxForm.reduxForm)({
  form: 'feedbackIncreaseLimits',
  validate: _validate2.default }))(_FeedbackIncreaseLimits2.default);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FeedbackIncreaseLimits/FeedbackIncreaseLimitsForm.js
// module id = 2634
// module chunks = 0